import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

const Author = ({
  date,
  image,
  label,
  name,
  className
}) => (
  <div className={classnames(
    'fb-author',
    className
  )}>
    {image && <img src={image} className='fb-author__image' alt={`${name}'s avatar`} />}
    <div className='fb-author__body'>
      {label && <div className='fb-author__label'>{label}</div>}
      {name && <div className='fb-author__name'>{name}</div>}
      {date && <div className='fb-author__name'>{date}</div>}
    </div>

  </div>
)

Author.propTypes = {
  /**
   * Pass an optional image element - this will display Author's avatar
   */
  image: PropTypes.string,
  /**
   * Pass an optional label element - this will display text above the Author's name
   */
  label: PropTypes.string,
  /**
   * Pass the person's name
   */
  name: PropTypes.string.isRequired,
  /**
   * Optionally add an additional class name
   */
  className: PropTypes.string
}

export default Author
